import React from "react";


import {
    SectionContainerComponent
} from "@Components/Sections";

import {
    BadgeCardComponent, IconCardComponent
} from "@Components/Elements/Cards";


import "./index.scss";


import iconMailL from "@Icons/SVG/icon-mail-l-white.svg";
import iconSecurityL from "@Icons/SVG/icon-security-l-white.svg";
import iconLegalL from "@Icons/SVG/icon-legal-l-white.svg";


export const ContactUsPageContactCategories:React.FC = () => {

    return (
        <SectionContainerComponent
            id={'contact-us-page__information-section'}
            sectionType={'main'}
        >

            <IconCardComponent
                cardIcon={{ iconSrc: iconMailL, iconSize: 'xl', iconBackground: 'primary' }}
                cardTitle={'General Inquiries'}
                cardSubTitle={'Questions about Qyvo, partnerships,or general support'}
                cardExtraDescription={`<a href={'mailto:hello@useqyvo.com'} title={'Contact Us'}><span>hello@useqyvo.com</span></a>`}
                xl={4}
            />

            <IconCardComponent
                cardIcon={{ iconSrc: iconSecurityL, iconSize: 'xl', iconBackground: 'primary' }}
                cardTitle={'Privacy & Data'}
                cardSubTitle={'Data protection, GDPR requests, and privacy concerns'}
                cardExtraDescription={`<a href={'mailto:privacy@useqyvo.com'} title={'Contact Us'}><span>privacy@useqyvo.com</span></a>`}
                xl={4}
            />

            <IconCardComponent
                cardIcon={{ iconSrc: iconLegalL, iconSize: 'xl', iconBackground: 'primary' }}
                cardTitle={'Legal & Compliance'}
                cardSubTitle={'Legal matters, compliance, and regulatory inquiries'}
                cardExtraDescription={`<a href={'mailto:legal@useqyvo.com'} title={'Contact Us'}><span>legal@useqyvo.com</span></a>`}
                xl={4}
            />

        </SectionContainerComponent>
    );

};


export default ContactUsPageContactCategories;
